import { Inject, Injectable } from '@angular/core';
import { EVENTS, IConfig as UnleashConfig, UnleashClient } from 'unleash-proxy-client';
import { fromEvent, Observable } from 'rxjs';
import { ImpressionEvent, UnleashConfigToken } from './interfaces';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

export interface IUnleashContextProperties {
  shopId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UnleashService {
  readonly unleash = new UnleashClient({ ...this.config, disableMetrics: true });

  readonly initialized$: Observable<any>;
  readonly error$: Observable<any>;
  readonly ready$: Observable<any>;
  readonly update$: Observable<any>;
  readonly impression$: Observable<any>;

  constructor(@Inject(UnleashConfigToken) private readonly config: UnleashConfig) {
    this.initialized$ = fromEvent<void>(this.unleash, EVENTS.INIT).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.error$ = fromEvent<unknown>(this.unleash, EVENTS.ERROR).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.ready$ = fromEvent<void>(this.unleash, EVENTS.READY).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.update$ = fromEvent<void>(this.unleash, EVENTS.UPDATE).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.impression$ = fromEvent<ImpressionEvent>(this.unleash, EVENTS.IMPRESSION).pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  isEnabled(featureName: string): boolean {
    return this.unleash.isEnabled(featureName);
  }

  isDisabled(featureName: string): boolean {
    return !this.isEnabled(featureName);
  }

  isEnabled$(featureName: string): Observable<boolean> {
    return this.update$.pipe(
      map(() => this.isEnabled(featureName)),
      distinctUntilChanged(),
    );
  }

  isDisabled$(featureName: string): Observable<boolean> {
    return this.isEnabled$(featureName).pipe(map((enabled) => !enabled));
  }
}
